import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { QuickActionType } from "../types";
import { useBrandQuickActions } from "./useBrandQuickActions";
import { useRetailerQuickActions } from "./useRetailerQuickActions";
export var useModalContent = function useModalContent() {
  var _quickActions$QuickAc, _quickActions$QuickAc2, _quickActions$QuickAc3, _quickActions$QuickAc4, _quickActions$QuickAc5, _quickActions$QuickAc6, _quickActions$QuickAc7, _quickActions$QuickAc8;
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var retailerQuickActions = useRetailerQuickActions();
  var brandQuickActions = useBrandQuickActions();
  var quickActions = _objectSpread(_objectSpread({}, retailerQuickActions), brandQuickActions);
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, QuickActionType.ACCEPT_AN_ORDER, {
    title: (_quickActions$QuickAc = quickActions[QuickActionType.ACCEPT_AN_ORDER]) === null || _quickActions$QuickAc === void 0 ? void 0 : _quickActions$QuickAc.label,
    description: strictLocalize({
      id: "ou6wIg",
      defaultMessage: [{
        "type": 0,
        "value": "Acepta nuevos pedidos proporcionando una fecha estimada de envío"
      }]
    }),
    buttonText: strictLocalize({
      id: "5e09EO",
      defaultMessage: [{
        "type": 0,
        "value": "Proporcionar una fecha estimada de envío"
      }]
    })
  }), QuickActionType.REQUEST_COMMISSION_CHANGE, {
    title: (_quickActions$QuickAc2 = quickActions[QuickActionType.REQUEST_COMMISSION_CHANGE]) === null || _quickActions$QuickAc2 === void 0 ? void 0 : _quickActions$QuickAc2.label,
    description: strictLocalize({
      id: "rAF6ME",
      defaultMessage: [{
        "type": 0,
        "value": "Solicita una modificación de la comisión de Faire Direct en los pedidos de los minoristas con los que ya tenías una relación de venta al por mayor anteriormente."
      }]
    }),
    buttonText: strictLocalize({
      id: "cX24dx",
      defaultMessage: [{
        "type": 0,
        "value": "Iniciar una solicitud de modificación de la comisión"
      }]
    })
  }), QuickActionType.EDIT_ITEM_AVAILABILITY, {
    title: (_quickActions$QuickAc3 = quickActions[QuickActionType.EDIT_ITEM_AVAILABILITY]) === null || _quickActions$QuickAc3 === void 0 ? void 0 : _quickActions$QuickAc3.label,
    description: strictLocalize({
      id: "b1DBx0",
      defaultMessage: [{
        "type": 0,
        "value": "Actualizar la disponibilidad de los artículos en los pedidos no enviados"
      }]
    }),
    buttonText: strictLocalize({
      id: "zkYVp5",
      defaultMessage: [{
        "type": 0,
        "value": "Modificar disponibilidad de los artículos"
      }]
    })
  }), QuickActionType.CANCEL_AN_ORDER, {
    title: (_quickActions$QuickAc4 = quickActions[QuickActionType.CANCEL_AN_ORDER]) === null || _quickActions$QuickAc4 === void 0 ? void 0 : _quickActions$QuickAc4.label,
    description: strictLocalize({
      id: "uw/QeA",
      defaultMessage: [{
        "type": 0,
        "value": "Cancela un pedido que aún no se ha tramitado o enviado"
      }]
    }),
    buttonText: strictLocalize({
      id: "sPg2u4",
      defaultMessage: [{
        "type": 0,
        "value": "Empezar cancelación"
      }]
    })
  }), QuickActionType.TRACK_AN_ORDER, {
    title: (_quickActions$QuickAc5 = quickActions[QuickActionType.TRACK_AN_ORDER]) === null || _quickActions$QuickAc5 === void 0 ? void 0 : _quickActions$QuickAc5.label,
    description: strictLocalize({
      id: "vvqBDw",
      defaultMessage: [{
        "type": 0,
        "value": "Ver la información de seguimiento de los pedidos que se han enviado"
      }]
    }),
    buttonText: strictLocalize({
      id: "uVSNXI",
      defaultMessage: [{
        "type": 0,
        "value": "Seguir el pedido"
      }]
    })
  }), QuickActionType.RETURN_ITEMS, {
    title: (_quickActions$QuickAc6 = quickActions[QuickActionType.RETURN_ITEMS]) === null || _quickActions$QuickAc6 === void 0 ? void 0 : _quickActions$QuickAc6.label,
    description: strictLocalize({
      id: "SM+WKr",
      defaultMessage: [{
        "type": 0,
        "value": "Devuelve artículos de los pedidos recibidos en los últimos 60 días. Solo se permite devolver el primer pedido que le hagas a cada marca."
      }]
    }),
    buttonText: strictLocalize({
      id: "ylvEif",
      defaultMessage: [{
        "type": 0,
        "value": "Iniciar una devolución"
      }]
    })
  }), QuickActionType.CONTACT_A_BRAND, {
    title: (_quickActions$QuickAc7 = quickActions[QuickActionType.CONTACT_A_BRAND]) === null || _quickActions$QuickAc7 === void 0 ? void 0 : _quickActions$QuickAc7.label,
    description: strictLocalize({
      id: "Tce2uo",
      defaultMessage: [{
        "type": 0,
        "value": "Ponte en contacto con las marcas si tienes preguntas concretas sobre un producto o dudas sobre los plazos de un pedido. Es la forma más rápida y mejor de resolver las cuestiones pendientes."
      }]
    }),
    buttonText: strictLocalize({
      id: "jHHKwS",
      defaultMessage: [{
        "type": 0,
        "value": "Enviar un mensaje a la marca"
      }]
    })
  }), QuickActionType.REPORT_DAMAGED_OR_MISSING_ITEMS, {
    title: (_quickActions$QuickAc8 = quickActions[QuickActionType.REPORT_DAMAGED_OR_MISSING_ITEMS]) === null || _quickActions$QuickAc8 === void 0 ? void 0 : _quickActions$QuickAc8.label,
    description: strictLocalize({
      id: "95bnr6",
      defaultMessage: [{
        "type": 0,
        "value": "Informa de problemas en el pedido en los 14 días siguientes a la entrega"
      }]
    }),
    buttonText: strictLocalize({
      id: "EfYP7O",
      defaultMessage: [{
        "type": 0,
        "value": "Empezar el informe sobre artículos dañados/no recibidos"
      }]
    })
  });
};